import { render, staticRenderFns } from "./EventValue.vue?vue&type=template&id=cfa8469a"
import script from "./EventValue.vue?vue&type=script&lang=js"
export * from "./EventValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports